import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { useClasses } from "@api/class.api";
import { BulkClassCommandsList } from "./BulkClassCommandsList";
import { CommandsListProps } from "./lib";

export const LineItemsBulkClassCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const {
        selectedLineItemCount = 0,
        hasSelectedAllMatchingLineItems = false,
        lineItemsApplyClasses,
    } = options;
    const { classesWithChildren, classesMap } = useClasses();

    return (
        <BulkClassCommandsList
            heading={
                hasSelectedAllMatchingLineItems
                    ? "Set class for all matching line items"
                    : `Set class for ${pluralizeWithCount("line item", selectedLineItemCount)}`
            }
            classTree={classesWithChildren}
            classesMap={classesMap}
            onApply={(classIds) => lineItemsApplyClasses?.(classIds)}
            onRemoveAll={() => lineItemsApplyClasses?.([])}
        />
    );
};
